import script from "./AdminManagementDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminManagementDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AdminManagementDashboard.vue?vue&type=style&index=0&id=53f6ba0b&lang=css"

const __exports__ = script;

export default __exports__